/**
 * Proof packet contracts.
 * Mirrors server/app/core/proof/proof_packet.py
 */

import { Bridge } from './bridge';
import { HourlyWeather } from './weather';
import { ModelVersion, SurfaceModelOutput } from './modeling';
import { Citation } from './mitigation';

export interface UncertaintyBounds {
  deck_temp_uncertainty_c: number;
  ice_thickness_uncertainty_mm: number;
  confidence_level: number;
}

export interface ProofInputs {
  bridge_id: string;
  forecast_start: string;
  forecast_end: string;
  requested_by: string;
  request_timestamp: string;
}

export interface ProofPacket {
  proof_id: string;
  generated_at: string;
  inputs: ProofInputs;
  bridge_params: Bridge;
  weather_series: HourlyWeather[];
  model_version: ModelVersion;
  derived_terms: Record<string, number>;
  outputs: SurfaceModelOutput[];
  uncertainty: UncertaintyBounds;
  calibration_events: CalibrationEventSummary[];
  citations: Citation[];
}

export interface CalibrationEventSummary {
  event_id: string;
  timestamp: string;
  correction: number;
}

export interface ProofSummary {
  proof_id: string;
  generated_at: string;
  bridge_name: string;
  forecast_start: string;
  forecast_end: string;
  timesteps: number;
  min_deck_temp_c: number;
  max_deck_temp_c: number;
  max_ice_thickness_mm: number;
  ice_hours: number;
  model_version: string;
  model_hash: string;
  citation_count: number;
}

export enum ExportFormat {
  JSON = 'json',
  CSV = 'csv',
  PDF = 'pdf',
  PNG = 'png',
  SVG = 'svg',
}
